import { render, staticRenderFns } from "./InlineLoadingMessage.vue?vue&type=template&id=706a837a&scoped=true"
import script from "./InlineLoadingMessage.vue?vue&type=script&lang=js"
export * from "./InlineLoadingMessage.vue?vue&type=script&lang=js"
import style0 from "./InlineLoadingMessage.vue?vue&type=style&index=0&id=706a837a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a837a",
  null
  
)

export default component.exports